export const enum JornadaEnum {
    SOCIOEMOCIONAL_PROFESSORES = 'SOCIOEMOCIONAL_PROFESSORES',
    ALF_360 = 'ALF_360',
    REALIZANDO_ESCOLHAS = 'REALIZANDO_ESCOLHAS',
    CRIATIVIDADE_PENSAMENTO_CRITICO = 'CRIATIVIDADE_PENSAMENTO_CRITICO',
    TRILHAS = 'TRILHAS',
    UNKNOWN = '_',
}
